// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Select',
    titleLinkTooltip: 'Go to page',
    collapseCardTooltip: 'Collapse the card',
    expandCardTooltip: 'Expand the card'
  },
  CardList: {
    loadMore: 'Load more',
    notFound: 'No items found.',
    toolbarSelect: 'Select',
    viewCards: 'Cards',
    viewTiles: 'Tiles',
    viewList: 'List',
    toolbarView: 'View'
  },
  ClosingConfirmation: {
    confirm: 'Leave',
    cancel: 'Go Back',
    content: "Are you sure you want to close and leave this window? Any data changes you've made won't be saved."
  },
  Cuttable: {
    showMore: 'Show more',
    showLess: 'Show less'
  },
  Dialog: {
    cancelButton: 'Cancel'
  },
  DrawerProgress: {
    cancelButton: 'Cancel'
  },
  Dropdown: {
    close: 'Close'
  },
  Form: {
    submitButton: 'Save',
    applyButton: 'Apply',
    cancelButton: 'Cancel'
  },
  FormField: {
    clear: 'Clear',
    remove: 'Remove',
    addMore: 'Add one more'
  },
  FormFieldPassword: {
    improvePassword: 'To improve your password:',
    passwordTooShort: 'Make the password longer.',
    lettersLowerCase: 'Use at least one lower-case character.',
    lettersUpperCase: 'Use at least one upper-case character.',
    numbers1: 'Use at least one number.',
    numbers3: 'Use at least three numbers.',
    specialChar1: 'Use at least one special character (for example: !, @, #, $, % ,^, &, *, ?, _, ~).',
    specialChar2: 'Use at least two special characters (for example: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Use both upper and lower-case characters.',
    comboLettersAndNumbers: 'Use both numbers and characters.',
    comboLettersNumbersSpecial: 'Use numbers, characters and special characters.',
    yourPasswordIsStrong: 'You can make it even stronger by increasing its length.',
    passwordStrength: 'The password strength is %%strength%%.',
    strengthVeryStrong: 'VERY STRONG',
    strengthStrong: 'STRONG',
    strengthVeryWeak: 'VERY WEAK',
    strengthWeak: 'WEAK',
    strengthMedium: 'MEDIUM',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    generateButton: 'Generate',
    copyButtonHint: 'Copy password',
    copySuccessToast: 'Password has been copied',
    generateButtonHint: 'Generate a strong password'
  },
  InPlaceEdit: {
    editButtonHint: 'Edit value',
    okButtonHint: 'Save changes',
    cancelButtonHint: 'Discard changes'
  },
  InputFile: {
    browseButton: 'Choose file...'
  },
  List: {
    totalRows: '%%totalRows%% items total',
    selectedRows: '%%selectedRows%% of %%totalRows%% items selected',
    all: 'All',
    allItemsOnPageSelected: 'All items on the page selected',
    allItemsSelected: 'All items selected',
    selectAllItems: 'Select all items',
    selectAllItemsOnPage: 'Select all items on the page',
    deselectAll: 'Deselect'
  },
  ListEmptyView: {
    filteredTitle: 'Could not find any items matching the filter',
    emptyTitle: "Looks like there's nothing here",
    filteredDescription: 'Refine your query or remove some of the criteria from the filter and try again.'
  },
  ListOperation: {
    cancelButton: 'Cancel'
  },
  Pagination: {
    totalShort: 'of %%total%%',
    itemsPerPage: 'Items per page',
    all: 'All',
    total: 'Page %%current%% of %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Close',
    cancelButton: 'Cancel'
  },
  Select: {
    noOptions: 'No options',
    placeholder: 'Select...'
  },
  SpotPopup: {
    total: '%%current%% of %%total%%'
  },
  Toaster: {
    closeGroup: 'Close group'
  }
};